exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lazyloadContainer {\r\n    overflow-y: scroll;\r\n    height: 510px;\r\n}\r\n.offsetLoader {\r\n    color: #337ab7;\r\n    font-size:24px;\r\n    margin-left:48%;\r\n    margin-top:20px;\r\n}\r\n.center{\r\n  width: 120px; \r\n}\r\n.loaderDiv {\r\n  position: absolute;   \r\n  top: 40%;                 \r\n  right: 50%;               \r\n  bottom: 0;\r\n  left: 50%;\r\n  z-index: 0;\r\n}\r\n.btn {\r\n   padding: 7px 12px;\r\n}\r\n.category-navs__container{\r\n  padding: 9px;\r\n}\r\n.dropdown-menu {\r\n    left: -55px;\r\n    min-width: 130px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/offer-detail/offer-detail.component.css
// module id = ../../../../../src/app/components/offer-detail/offer-detail.component.css
// module chunks = main